import { render, staticRenderFns } from "./CodeStatement.vue?vue&type=template&id=04dc95a0"
import script from "./CodeStatement.vue?vue&type=script&lang=js"
export * from "./CodeStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports